import {
  EmptyState,
  EmptyStateBody,
  Spinner,
  Content,
} from "@patternfly/react-core";
import { useTranslation } from "react-i18next";

const LoadingEmptyState = () => {
  const { t } = useTranslation("loading-empty-state");
  return (
    <EmptyState icon={Spinner}>
      <EmptyStateBody>
        <Content component="p">{t("text")}</Content>
      </EmptyStateBody>
    </EmptyState>
  );
};

export default LoadingEmptyState;
